import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { flattenStyles } from '@angular/platform-browser/src/dom/dom_renderer';
import { AlertService } from '../../services/alert.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-simple-player',
  templateUrl: './simple-player.component.html',
  styleUrls: ['./simple-player.component.scss']
})
export class SimplePlayerComponent implements OnInit, OnDestroy {
  @Input() filename: string;
  audio: any;
  playing = false;
  disabled: boolean;

  constructor(private alertService: AlertService
    , private router: Router) {

  }

  ngOnInit() {
    // if (!this.filename) {
    //   this.disabled = true;
    // } else {
    //   this.disabled = false;
    // }
  }

  ngOnDestroy() {
  }
  playSound() {
    if (this.playing) {
      this.stopHtml5();
      return;
    }

    if (this.useAudioContext() && this.fileExtensionSupported()) {
      this.audio = new Audio();
      this.playHtml5();
    } else {
      this.downloadAudio();
    }
  }

  private useAudioContext() {
    return window.navigator.mediaDevices;
  }

  private fileExtensionSupported() {
    const tmp = this.filename.toLowerCase().split('?');
    const extension = tmp[0].split('.').pop();
    console.log(this.filename);
    console.log(extension);
    return extension === 'wav' || extension === 'mp3';
  }

  private downloadAudio() {
    window.open(this.filename);
  }

  private playHtml5() {
    this.audio = new Audio();
    this.playing = true;
    this.audio.addEventListener('error', f => {
      console.log(f.target.error);
      console.log(f.target);
      this.alertService.showError('An unhandled exception occurred while loading sound file.');
      this.playing = false;
    });
    this.audio.addEventListener('ended', f => {
      this.playing = false;
    });
    this.audio.src = this.filename;
    this.audio.load();
    this.audio.play();
  }

  private stopHtml5() {
    this.audio.pause();
    this.audio.currentTime = 0.0;
    this.playing = false;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/components/simple-player/simple-player.component.ts